export default __webpack_public_path__ + "assets/e69f72b5dd08e8c87738d678073f6751.svg";